// 补全子元素的color
// 一级标签按标签id升序排列，即新加标签排在下方；
// 二级标签先按照父标签分组，同一个父标签下再按标签id升序排列；
// 三级标签同理，先按照一级标签分组，再按照二级标签分组，同一个二级父标签下按标签id升序
import { createSelector } from 'reselect';
import _ from 'lodash';
import prefixInteger from '../prefix-integer';

const buildChildConvTag = createSelector([convTag => convTag], convTagState => {
  const convTag = convTagState;
  if (convTag.size === 0) {
    return convTag;
  }
  const setChildColor = (id, color) => {
    const index = convTag.findIndex(val => val.id === id);
    convTag[index].color = color;
  };
  const setOrder = (id, order) => {
    const index = convTag.findIndex(val => val.id === id);
    convTag[index].order = order;
  };
  // 初始化 最上层的order
  convTag
    .filter(val => val.level === 1)
    .forEach(val => {
      setOrder(val.id, prefixInteger(val.id, 8));
    });

  [2, 3].forEach(level => {
    const nowTags = convTag.filter(val => val.level === level);
    const parentTags = convTag.filter(val => val.level === level - 1);
    nowTags.forEach(nowTag => {
      const parent = parentTags.find(parentTag => parentTag.id === nowTag.parent_id);
      setChildColor(nowTag.id, parent.color);
      setOrder(nowTag.id, `${parent.order}_${prefixInteger(nowTag.id, 6)}`);
    });
  });
  return _.sortBy(convTag, 'order');
});

export default buildChildConvTag;
